var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "col-12" }, [
    _c(
      "div",
      {
        staticClass: "alert-container alert-discount",
        class: _vm.additionalClass,
        attrs: { role: "alert" },
      },
      [
        _c("p", { staticClass: "alert" }, [
          _c("span", {
            staticClass: "alert-icon",
            class: _vm.dto.icon,
            attrs: { "aria-hidden": "true" },
          }),
          _vm._v(" "),
          _c("span", {
            staticClass: "ob1-alert-title",
            domProps: { innerHTML: _vm._s(_vm.dto.title) },
          }),
        ]),
        _vm._v(" "),
        _vm.showDescription || _vm.showLink
          ? _c("div", { staticClass: "alert-content" }, [
              _vm.showDescription
                ? _c("p", {
                    staticClass: "alert-text",
                    domProps: { innerHTML: _vm._s(_vm.dto.description) },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showLink
                ? _c(
                    "a",
                    {
                      staticClass: "ob1-link-arrow ob1-link-dark",
                      attrs: {
                        href: _vm.dto.link,
                        "data-oevent-category": _vm.dto.linkTms.category,
                        "data-oevent-action": _vm.dto.linkTms.action,
                        "data-oevent-label": _vm.dto.linkTms.label,
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.dto.linkLabel) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }